import { styled } from 'styled-components'

export const PlaceholderContainer = styled.div`
    text-align: center;
    padding: 20px;
    background-color: #f9f9f9;
    border: 1px dashed #ccc;
    border-radius: 5px;
    margin: 20px 0;
    color: #555;
    font-size: 1.2em;
    width: 100%;
    box-sizing: border-box;

    @media (max-width: 768px) {
        width: 90%;
        padding: 16px 1rem;
        margin: 16px auto;
        font-size: 1em;
        max-width: 100%;
    }
`
